import React, {useState, useContext} from 'react'
import {Context} from '../index';
import config from '../config';
import {useTranslation} from 'react-i18next';

export default function RegistrationForm() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [position, setPosition] = useState('');
    const {store} = useContext(Context);
    const {t} = useTranslation();

    const positions = config.positionNames;

    return (
        <div>
            <input
                type='text'
                value={email}
                placeholder={t('label.login')}
                onChange={event => setEmail(event.target.value)}
            />
            <input
                type="password"
                value={password}
                placeholder={t('label.password')}
                onChange={event => setPassword(event.target.value)}
            />
            <select value={position} onChange={(e) => setPosition(e.target.value)}>
                <option value="">{t('label.position')}</option>
                {positions.map((pos, index) => {
                    return (
                        <option key={index} value={pos}>
                            {pos}
                        </option>
                    );
                })}
            </select>
            <button onClick={() => {
                store.registration(email, password, position);
                setEmail('');
                setPassword('');
                setPosition('');
            }}>
                {t('btn.register')}
            </button>
        </div>
    )
}
